import { baseApi } from 'core/api';
import { useAutoRechargeStore, useOrganizationStore } from 'store/modules';

const state = () => ({
    _subscription: null,
    _showUpgradePlan: false,
});

const getters = {
    subscription: (state) => state._subscription,
    upgradePlanShown: (state) => state._showUpgradePlan,
    hasSubscriptionNumbers: (state) => !!state._subscription?.numbers?.left,
    hasSubscriptionSeats: (state) => !!state._subscription?.seats?.left,
};

const actions = {
    getSubscription() {
        return baseApi.get('core/organization/subscription').then((response) => {
            this._setSubscription(response.data);

            return response.data;
        });
    },

    _setSubscription(data) {
        this._subscription = data;
    },

    showUpgradePlanModal() {
        this._showUpgradePlan = true;
    },

    hideUpgradePlanModal() {
        this._showUpgradePlan = false;
    },

    subscriptionUpgraded(data) {
        useAutoRechargeStore()._setSubscription(data);
        useOrganizationStore()._setSubscription(data);
    },

    subscriptionUpdated(subscription) {
        this._subscription = {
            ...this._subscription,
            ...subscription,
        };
    },
};

export default {
    state,
    getters,
    actions,
};
